<template>
  <div class="customizer-design-tab flex-container collapse-s">
    <div class="steps">
      <template v-for="(optionGroup, index) in optionGroups">
        <design-options
          :active="stepActive(optionGroup)"
          :selected="validCart"
          :unlocked="stepUnlocked(index)"
          :option-group="optionGroup"
          v-if="optionGroup.code=='DESIGNOPTIONS'"
          :key="`${optionGroup.code}_optionSelector`"
        ></design-options>
        <image-options
          :active="stepActive(optionGroup)"
          :selected="stepSelected(index)"
          :unlocked="stepUnlocked(index)"
          :optionGroup="optionGroup"
          v-else-if="isImageLayout(optionGroup) && optionGroup.options.length > 1"
          :key="`${optionGroup.code}_optionSelector`"
        ></image-options>
        <radio-options
          :active="stepActive(optionGroup)"
          :selected="stepSelected(index)"
          :unlocked="stepUnlocked(index)"
          :optionGroup="optionGroup"
          v-else-if="optionGroup.options.length > 1"
          :key="`${optionGroup.code}_optionSelector`"
        ></radio-options>
      </template>
    </div><!-- /.steps -->
    <div class="previewer">
      <div class="previewer-content flex-container is-vertical">
        <arranger></arranger>
        <bottom-bar></bottom-bar>
      </div>
    </div><!-- /.previewer -->
    <div class="show-mobile mobile-bottom-bar">
      <bottom-bar></bottom-bar>
    </div><!-- /.show-mobile -->
  </div><!-- /.customizer-design-tab -->
</template>

<script>
import DesignOptions from "@/components/steps/DesignOptions"
import ImageOptions from "@/components/steps/ImageOptions"
import RadioOptions from "@/components/steps/RadioOptions"
import Arranger from "@/components/previewer/Arranger"
import BottomBar from "@/components/previewer/BottomBar"
import { mapState } from "vuex"

export default {
  name: "DesignTab",
  components: {
    DesignOptions,
    ImageOptions,
    RadioOptions,
    Arranger,
    BottomBar
  },
  computed: {
    ...mapState([
      "optionGroups",
      "uploadedPhotos",
      "selectedOptions",
      "activeOptionGroup",
      "validCart"
    ])
  },
  methods: {
    stepActive(optionGroup) {
      return !!(this.activeOptionGroup && this.activeOptionGroup.code === optionGroup.code);
    },
    stepSelected(index) {
      if (index == 0) {
        return !!(this.uploadedPhotos && this.uploadedPhotos.length);
      }

      // If uploaded photos and either current group is selected
      return !!(
        this.uploadedPhotos &&
        this.uploadedPhotos.length &&
        !!(this.selectedOptions[this.optionGroups[index].code] && this.selectedOptions[this.optionGroups[index].code].selected)
      );
    },
    stepUnlocked(index) {
      if (index == 0) {
        return !!(this.uploadedPhotos && this.uploadedPhotos.length);
      }
      // If uploaded photos and either the previous group has a selected option or the current group has a selected option
      // TODO: Fix random cannot read property selected of undefined - occurs when new option groups exist that didn't exist when an option is selected
      return !!(
        this.uploadedPhotos &&
        this.uploadedPhotos.length &&
        !!(
          this.selectedOptions[this.optionGroups[index - 1].code].selected ||
          (this.selectedOptions[this.optionGroups[index].code] &&
            this.selectedOptions[this.optionGroups[index].code].selected)
        )
      );
    },
    isImageLayout(optionGroup) {
      // Check second option, because optional groups will have an optional item with image inserted at index 0
      return (
        optionGroup.options[1].optionData &&
        optionGroup.options[1].optionData.ImageUrl
      );
    }
  }
}
</script>
